import React, { createContext, ReactNode, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ActiveFilter } from '../FiltersMenu';
import { parseFiltersFromQuery } from '../../ideasHelpers';
import {useIdeaFilters} from "../../../../hooks/useIdeaFilters";

interface FiltersContextData {
    openedMenuType: "idea" | "evidence" | null;
    setOpenedMenuType: React.Dispatch<React.SetStateAction<"idea" | "evidence" | null>>;
    activeFilters: ActiveFilter[];
    setActiveFilters: React.Dispatch<React.SetStateAction<ActiveFilter[]>>
    selectedParentFilter: string | null;
    setSelectedParentFilter: React.Dispatch<React.SetStateAction<string | null>>;
    checkedComponents: { [key: string]: any[] };
    setCheckedComponents: React.Dispatch<React.SetStateAction<{[key: string]: any[];}>>
    childFiltersValue: { [key: string]: any[] };
    setChildFiltersValue: React.Dispatch<React.SetStateAction<{ [key: string]: any[] }>>;
    parentQuery: string;
    setParentQuery: React.Dispatch<React.SetStateAction<string>>;
    childQuery: { [x: string]: string } | undefined;
    setChildQuery: React.Dispatch<React.SetStateAction<{ [x: string]: string } | undefined>>;
    operator: { [x: string]: string } | undefined;
    setOperator: React.Dispatch<React.SetStateAction<{ [x: string]: string } | undefined>>;
    numberValue: { [parent: string]: number } | undefined;
    setNumberValue: React.Dispatch<React.SetStateAction<{ [parent: string]: number } | undefined>>;
    rangeDates: { [parent: string]: [Date | null, Date | null] } | undefined;
    setRangeDates: React.Dispatch<React.SetStateAction<{ [parent: string]: [Date | null, Date | null] } | undefined>>;
    subPageKey: string | undefined;
    editMode: boolean;
    setEditMode: React.Dispatch<React.SetStateAction<boolean>>
  }
  

interface FiltersContextProviderProps {
  children: ReactNode;
  initialSubpageKey?: string | null;
}

const FiltersContext = createContext<FiltersContextData>({} as FiltersContextData);

export const FiltersContextProvider = ({ children, initialSubpageKey }: FiltersContextProviderProps) => {
  const location = useLocation();
  const { ideasFiltersConfig } = useIdeaFilters();
  
  const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(
    parseFiltersFromQuery(location.search, ideasFiltersConfig) ?? []
  );

  const [openedMenuType, setOpenedMenuType] = useState<"idea" | "evidence" | null>(null);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [selectedParentFilter, setSelectedParentFilter] = useState<string | null>(null);
  const [checkedComponents, setCheckedComponents] = useState<{ [key: string]: any[] }>({});
  const [childFiltersValue, setChildFiltersValue] = useState<{ [key: string]: any[] }>({});
  const [parentQuery, setParentQuery] = useState<string>("");
  const [childQuery, setChildQuery] = useState<{ [x: string]: string } | undefined>(undefined);
  const [operator, setOperator] = useState<{ [x: string]: string } | undefined>(undefined);
  const [numberValue, setNumberValue] = useState<{ [parent: string]: number } | undefined>(undefined);
  const [rangeDates, setRangeDates] = useState<{ [parent: string]: [Date | null, Date | null] } | undefined>(undefined);
  const subPageKey = initialSubpageKey ?? undefined;


  return (
    <FiltersContext.Provider value={{
      openedMenuType,
      setOpenedMenuType,
      activeFilters,
      setActiveFilters,
      selectedParentFilter,
      setSelectedParentFilter,
      checkedComponents,
      setCheckedComponents,
      childFiltersValue,
      setChildFiltersValue,
      parentQuery,
      setParentQuery,
      childQuery,
      setChildQuery,
      operator,
      setOperator,
      numberValue,
      setNumberValue,
      rangeDates,
      setRangeDates,
      subPageKey,
      editMode,
      setEditMode
    }}>
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersContext;


